module.exports = __webpack_public_path__ + "img/shuxian11111.b26c8971.png";